export const LimitFunc = (data: any) => {
  return {
    results: data?.calculated_limits?.map((i: any) => ({
      limit_amount: i?.limit_amount,
      amount: i?.left_amount,
      name: i?.name,
    })),
  };
};
